import * as React from "react";

import { makeStyles, Tab, Tabs } from "@material-ui/core";
import clsx from "clsx";
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  tabContainer: (props) => ({
    borderRadius: "10px",
    padding: "10px 0px",
    overflow: "visible !important",
    maxWidth: "100%",

    "&::-webkit-scrollbar": {
      width: "10px",
      height: "13px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ededed",
      borderRadius: "50px",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "6px",
      border: "4px solid rgba(0, 0, 0, 0)",
      backgroundClip: "padding-box",
      backgroundColor: "#8898aa",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#525b67",
    },
    "& .MuiTab-wrapper": {
      padding: "5px",
      borderRadius: "10px",
      fontSize: "1.418rem !important",
      fontWeight: "bold",
      fontFamily: "Vazir-Bold",
    },

    "& .MuiTabs-scroller": {
      overflow: "visible !important",
    },
    "& .MuiTab-root": {
      minWidth: "0 !important",
    },
    "& .MuiTabs-flexContainer": {
      gap: 5,
      borderBottom: "solid 1px #aaa",
      width: "100%",

      [theme.breakpoints.down("md")]: {
        overflow: "scroll",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
    },
    "& .Mui-selected": {
      "& .MuiTab-wrapper": {
        borderRadius: "10px",
        color: "#0A369D",
        textAlign: "center",
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#0A369D",
      height: "3px",
      borderRadius: "50px",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
  }),
  singleTab: {
    position: "relative",
    width: "fit-content",
  },
}));
const NewPublicTabs = ({
  data,
  tab,
  setTab,
  handleTabChange,
  customClassName,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Tabs
      value={tab}
      onChange={handleTabChange}
      className={clsx(classes.tabContainer, customClassName && customClassName)}
    >
      {data.map((tabData) => (
        // <div className={classes.singleTab}>
        <Tab
          key={uuid()}
          disableRipple
          disableFocusRipple
          disableTouchRipple
          label={tabData}
          {...props}
        />
        // <div className={classes.divider} />
        // </div>
      ))}
    </Tabs>
  );
};

export default NewPublicTabs;
